/* tslint:disable */
/* eslint-disable */

/**
 * 0 = Half
 * 
 * 1 = Full
 * 
 * 2 = Bar
 * 
 * 3 = Bush
 * 
 * 4 = Shackles
 * 
 * 5 = MasterLinks
 * 
 * 6 = FlatPlates
 * 
 * 7 = WireRope
 * 
 * 8 = RoseJoints
 * 
 * 9 = LiftingEyes
 * 
 * 10 = None
 */
export enum CalibrationBlockType {
  Half = 0,
  Full = 1,
  Bar = 2,
  Bush = 3,
  Shackles = 4,
  MasterLinks = 5,
  FlatPlates = 6,
  WireRope = 7,
  RoseJoints = 8,
  LiftingEyes = 9,
  None = 10
}
